import { render, staticRenderFns } from "./ForumChatPoll.vue?vue&type=template&id=3b08c1b4&scoped=true"
import script from "./ForumChatPoll.vue?vue&type=script&lang=js"
export * from "./ForumChatPoll.vue?vue&type=script&lang=js"
import style0 from "./ForumChatPoll.vue?vue&type=style&index=0&id=3b08c1b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b08c1b4",
  null
  
)

export default component.exports